import(/* webpackMode: "eager" */ "/vercel/path0/src/app/inquiry/page.tsx");
